import store from '../store/store'

export default function Controls(opts={}){
    BaseConstructor.call(this)
    let {container} = opts
    let elements = {}
    let context = this

    this.generate = () =>{
        elements.container = this.createElement('div', 'flex flex-gap-xs flex-v-center flex-h-center')
        elements.play_button = this.createElement('div', 'timeline-control-config-button playbutton-container')
        elements.config_button = this.createElement('div', 'timeline-control-config-button configbutton-container', '<i class="fas fa-cog"></i>')

        $(elements.container).append(elements.config_button,elements.play_button)

        setPlayBtnContent()

        $(container).append(elements.container)

        $(elements.play_button).on('click', _ =>{
            store.setOption('play', !store.getOption('play'))
        })
        $(elements.config_button).on('click', _ =>{
            store.setOption('show_config_form', !store.getOption('show_config_form'))
        })
        
    }

    this.setPlayBtnContent = boolean =>{
        setPlayBtnContent(boolean)
    }

    this.destroy = () =>{
        $(elements.container).html('')
        setPlayBtnContent = _ => null
        elements = {}
    }

    let setPlayBtnContent = boolean =>{
        let current = boolean != undefined ? boolean : store.getOption('play')
        $(elements.play_button).html(current ? '<i class="fas fa-pause"></i>' : '<i class="fas fa-play"></i>')
    }

    init()

    function init(){
        store.subscribe('SET_OPTION', data=>{
            if(data.option === 'play'){
                setPlayBtnContent()
            }
        })
    }
}

Controls.prototype = Object.create(BaseConstructor.prototype)